import { useQuery, UseQueryResult } from 'react-query';
import { ArticleListItems } from '../../models/ArticleListItems';
import { FetchArticlesParams } from '../../services/articles/articles.models';
import { mapToArticleListItems } from './utils/article.mappers';
import { fetchArticles, fetchMyFeedArticles } from '../../services/articles/articles.service';
import { queryKeys } from '../queryKeyFactory';

export default (params: FetchArticlesParams): UseQueryResult<ArticleListItems, Error> => {
  const { isMyFeed, enabled } = params;
  return useQuery<ArticleListItems, Error>(
    queryKeys.fetchArticles.feedByParams(params),
    async () => {
      const articleListDto = isMyFeed ? await fetchMyFeedArticles(params) : await fetchArticles(params);
      return mapToArticleListItems(articleListDto);
    },
    {
      enabled,
    }
  );
};
